import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadOptions } from '../Options/preloadOptions';

import useDraftsDataHomeDraftsQuery, {
	type useDraftsDataHomeDraftsQuery$data,
	type useDraftsDataHomeDraftsQuery$variables,
} from './__generated__/useDraftsDataHomeDraftsQuery.graphql';
import { getDraftsQueryOptions } from './draftsQueryHelpers';

export const preloadDrafts = ({ isLoggedIn }) => {
	const { variables } = getDraftsQueryOptions({});
	return waitForAllReturnWhenError([
		query<useDraftsDataHomeDraftsQuery$data, useDraftsDataHomeDraftsQuery$variables>({
			query: useDraftsDataHomeDraftsQuery,
			variables,
		}),
		preloadOptions({ isLoggedIn }),
	]);
};
